import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { PatientSummaryScreen } from 'screens/patient';

export default withPermissions(PatientSummaryScreen, [
  GroupSecurity.ClinicalImpressionRead,
]);
